import { render } from "./SelfEvaluation.vue?vue&type=template&id=227da4da&scoped=true"
import script from "./SelfEvaluation.vue?vue&type=script&lang=js"
export * from "./SelfEvaluation.vue?vue&type=script&lang=js"

import "./review-evaluate.scss?vue&type=style&index=0&id=227da4da&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227da4da"]])

export default __exports__